import config from '../../config.json';
export default {
	site_url: app.site_url,
	api_url: app.api_url,
	config: config
}